export const Orders = () => {
  return (
    <>
      Orders
    </>
  )
}